import React from "react";

import { Box, Skeleton, Stack, styled, Typography } from '@material-ui/core';

import { actions } from '../../services/support';
import { useEffect } from "react";
import { StringParam, useQueryParam } from "use-query-params";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { MessageData, MessageGiphyData, MessagePhotoData, MessageTranslatedData, MesssageStickerData } from "../../types";
import { ProfileAvatar } from "../../components/UserPhoto/UserPhoto";
import timeAgo from "../../utils/timeAgo";


const MsgPhoto = styled('img')({
  borderRadius: '10px',
  width: 300,
  cursor: 'zoom-in',
});

interface MsgProps {
  message: MessageData;
}

export const MessageItem: React.FC<MsgProps> = ({ message }) => {


  const right = message.fromUserId === 'admin';

  const renderContent = () => {
    if (message.type === 'photo') {
      const data = message.data as MessagePhotoData;
      return (
        <a href={`${process.env.REACT_APP_CDN_URL}/${data.path}`} target="_blank" rel="noreferrer">
          <MsgPhoto src={`${process.env.REACT_APP_CDN_URL}/${data.path}`} alt={message.id} />
        </a>
      )
    }

    if (message.type === 'sticker') {
      const data = message.data as MesssageStickerData;
      return <img src={`${process.env.REACT_APP_CDN_URL}/${data.path}`} alt={message.id} width={50} />
    }

    if (message.type === 'giphy') {
      const data = message.data as MessageGiphyData;
      return <img src={data.url} alt={message.id} width={200} />
    }

    if (message.type === 'translated') {
      const data = message.data as MessageTranslatedData;
      return <Typography>{data.en}</Typography>
    }


    return (

      <Box sx={{
        backgroundColor: '#eee',
        p: 1,
        borderRadius: '10px',
        borderTopRightRadius: right ? 0 : '10px',
        borderTopLeftRadius: !right ? 0 : '10px',
      }}>
        <Typography>{message.data}</Typography>
      </Box>

    );
  }



  return (
    <Stack direction="column" alignItems={right ? 'flex-end' : 'flex-start'}>
      <Stack direction="row" spacing={1}>
        {right ? null : <ProfileAvatar userId={message.fromUserId} size={25} />}
        {
          renderContent()
        }
        {!right ? null : <ProfileAvatar userId={message.fromUserId} size={25} />}
      </Stack>
      <Typography variant="caption">
        {timeAgo(message.createTime ? message.createTime.toDate() : new Date())}
      </Typography>
    </Stack>
  )
}

const Root = styled('div')({
  flex: 1,
});

const SupportMessages: React.FC = () => {
  const dispatch = useDispatch();
  const [ selectedChat ] = useQueryParam('id', StringParam);

  const state = useSelector((state: RootState) => state.support);

  useEffect(() => {
    if (!selectedChat) {
      return;
    }

    dispatch(actions.resetMessages());
    dispatch(actions.loadMessages(selectedChat));

    return () => {
      dispatch(actions.resetMessages());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ selectedChat ]);



  return (
    <Root>
      <Stack direction="column" spacing={1}>
        {
          state.messagesLoading ? (
            <React.Fragment>
              <Skeleton variant="text" />
              <Skeleton variant="text" />
              <Skeleton variant="text" />
            </React.Fragment>
          ) : (
            state.messages.map(msg => <MessageItem message={msg} key={msg.id} />)
          )
        }
      </Stack>
    </Root>
  );
};

export default SupportMessages;